import { ScheduleOfActivities, toScheduleOfActivities } from '@faro/study-designer-model';
import axios from 'axios';
import { Identifiable } from 'faro-common-model';
import { EpochConfigurationQueryParameters } from '../EpochConfiguration/EpochConfigurationClient';
import { StudyPathParameter } from '../parameter';

export type ScheduleOfActivitiesPathParameters = StudyPathParameter;
export type ScheduleOfActivitiesQueryParameters = EpochConfigurationQueryParameters & {
    revision?: string;
};

/**
 * Client responsible for accessing the backend entity services
 */
export const scheduleOfActivitiesClient = {
    list: async (
        request?: ScheduleOfActivitiesPathParameters & ScheduleOfActivitiesQueryParameters,
        signal?: AbortSignal
    ): Promise<ScheduleOfActivities[]> => {
        const { studyId, ...query } = request ?? {};
        return axios
            .get(`/api/study-designer/studies/${studyId}/schedule-of-activities`, {
                signal,
                params: query,
            })
            .then(response => response.data?.map(toScheduleOfActivities) ?? []);
    },
    get: async (
        request: ScheduleOfActivitiesPathParameters & Identifiable & { revision?: string },
        signal?: AbortSignal
    ): Promise<ScheduleOfActivities> => {
        const { studyId, id, revision } = request;
        return axios
            .get(`/api/study-designer/studies/${studyId}/schedule-of-activities/${id}`, {
                signal,
                params: revision ? { revision } : undefined,
            })
            .then(response => toScheduleOfActivities(response.data));
    },
    map: toScheduleOfActivities,
};
